var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity-log',{attrs:{"title":"Audit Trail","scope":_vm.scope,"locked-fields":_vm.lockedFields,"saved-views":_vm.savedViews}})}
var staticRenderFns = []

export { render, staticRenderFns }